import React, { JSX } from 'react';
import styles from './OttMiniSummaryCard.module.scss';
import { countZero, replacePlaceholder, viewport } from '../../utils/utils';
import Row from '../ResponsiveRow';

export interface ProductItem {
  changeText: string;
  month: string;
  changeIcon: any;
  title:string;
  hsDevicesLabel: string;
  hsAdditionalAccLabel: string;
}

export interface OttMiniSummaryCardProps {
  content: ProductItem;
  cartData: any;
  redirectionUrl?: string;
}

const OttMiniSummaryCard = ({ content, cartData, redirectionUrl }: OttMiniSummaryCardProps): JSX.Element => {
  const viewPortType = viewport();
  return (
    <Row>
      <section className={styles.wrapper} aria-labelledby='summary-heading'>
        {content?.title && <h3 id='summary-heading' className={styles.heading}>{content?.title}</h3>}
        {cartData?.map((item: any, index: number) => {
          return (
            <article
              key={index}
              className={styles.cardContainer}
              role='region'
              aria-label='Selected products summary'
            >
              {/* Image and Product Title Section */}
              <div className={styles.imageProductWrapper}>
                {item?.hardwareImageUrl && (
                  <div className={styles.imageContainer}>
                    <img
                      src={item?.hardwareImageUrl}
                      alt={`${item?.itemName} icon`}
                      className={styles.productIcon}
                      width={viewPortType === 'mobile' ? 64 : 96}
                      height={viewPortType === 'mobile' ? 64 : 96}
                    />
                  </div>
                )}
                <div className={styles.contentContainer}>
                  {/* {item?.isHardware ? (
                    <>
                      <div className={styles.headingText}>{item?.hardwareProductTitle}</div>
                      {item?.hardwareDetails && (
                        <div className={styles.hardwareDetails}>{item?.hardwareDetails}</div>
                      )}
                      <div className={styles.hardwarePayment}>
                        In 24 monthly installments. Down payment: {countZero(1)}.–
                      </div>
                    </>
                  ) : ( */}
                    <div className={styles.productsSection}>
                      <span
                        className={styles.productName}
                        aria-label={`Selected product: ${item?.itemName}`}
                      >
                        {item?.itemName}
                      </span>
                    </div>
                  {/* )} */}
                  {item?.itemType === 'HOME_SECURITY' && (
                    <div className={styles.hardwarePayment}>
                      {content?.hsDevicesLabel && <span>{content?.hsDevicesLabel}</span>} {' '}
                      {item?.accessoryCount > 0 &&
                        content?.hsAdditionalAccLabel &&
                        replacePlaceholder(content?.hsAdditionalAccLabel, [item?.accessoryCount])}
                    </div>
                  )}
                </div>
              </div>

              {/* Price Section */}
              <div className={styles.priceContainer}>
                {item?.itemDerivedPrice ? (
                  <>
                    <span
                      className={styles.actualPrice}
                      aria-label={`Total price: ${countZero(
                        Number(item?.itemDerivedPrice).toFixed(2)
                      )} per month`}
                    >
                      {countZero(Number(item?.itemDerivedPrice).toFixed(2))}
                      <span aria-hidden='true'>{content?.month}</span>
                    </span>
                    <span
                      className={styles.basePrice}
                      aria-label={`Original price: ${countZero(
                        Number(item?.itemDiscountedPrice).toFixed(2)
                      )}`}
                    >
                      {countZero(Number(item?.itemDiscountedPrice).toFixed(2))}
                    </span>
                  </>
                ) : item?.itemOneTimePrice ? <span
                    className={styles.actualPrice}
                    aria-label={`Total price: ${countZero(
                      Number(item?.itemDiscountedPrice).toFixed(2)
                    )} per month`}
                  >
                    {countZero(Number(item?.itemOneTimePrice).toFixed(2))}
                    <span aria-hidden='true'>/-</span>
                  </span> : (
                  <span
                    className={styles.actualPrice}
                    aria-label={`Total price: ${countZero(
                      Number(item?.itemDiscountedPrice).toFixed(2)
                    )} per month`}
                  >
                    {countZero(Number(item?.itemDiscountedPrice).toFixed(2))}
                    <span aria-hidden='true'>{content?.month}</span>
                  </span>
                )}
              </div>

              {/* Change Button Section - Show on last element if 2 cards, always show if 1 card */}
              {(cartData?.length === index + 1) && (
                <div className={styles.actionContainer}>
                  <button
                    className={styles.changeButton}
                    aria-label='Change selected products'
                    type='button'
                    onClick={() => {
                      // const redirectionUrl = returnPreviousUrl(is4pFlow ? '4P' : item?.itemType);
                      if (redirectionUrl) {
                        window.location.href = redirectionUrl;
                      }
                    }}
                  >
                    {viewPortType !== 'mobile' && content?.changeText}
                    <img src={content?.changeIcon?.filename} alt='edit icon' role='presentation' />
                  </button>
                </div>
              )}
            </article>
          );
        })}
      </section>
    </Row>
  );
};

export default OttMiniSummaryCard;
